<template>
  <div>
    <loading-anim :active="$store.state.loading" fullScreen></loading-anim>
    <b-navbar class="navbar" toggleable="lg">
      <router-link to="/"><b-navbar-brand><img :class="getLogoClasses" :style="getLogoStyles" :src="getLogo"/></b-navbar-brand></router-link>
      <!-- <b-navbar-toggle target="nav-collapse"></b-navbar-toggle> -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item>
          <base-button class="btn-layout" @click="back"  v-if="!$route.meta.hideRightBackButton">
            <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" class="mr-2" color="white" svgClasses="reverse"/>
            <span>{{ $t('back') }}</span>
          </base-button>
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
    <div class="pb-5 ctm-container">
      <h3 class="mb-3 mb-md-5 text-center" v-if="$route.meta.title && !$route.meta.title.hide ? getMetaTitle : null">{{ getMetaTitle }}</h3>
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
      <AddToHomeScreen v-if="showInstallAppButton" animate shadow class="add-to-home-screen"></AddToHomeScreen>
    </div>
  </div>
</template>

<script>
import layoutMixin from '@/mixins/layout.mixin'
import gtagMixin from '@/mixins/gtag.mixin'
import { BNavbar, BNavbarNav, BNavbarBrand, BNavbarToggle, BCollapse, BNavItem } from 'bootstrap-vue'
import AddToHomeScreen from '@/components/utils/AddToHomeScreen'

export default {
  mixins: [layoutMixin, gtagMixin],
  components: {
    'loading-anim': () => import('@/components/utils/LoadingAnim'),
    BNavbar,
    BNavbarNav,
    BNavbarBrand,
    BNavbarToggle,
    BCollapse,
    BNavItem,
    AddToHomeScreen
  },
  data () {
    return {
      key: this.$route.path
    }
  },
  methods: {
    back () {
      window.history.back()
    }
  },
  computed: {
    showInstallAppButton () {
      return this.$route.meta && this.$route.meta.showInstallAppButton
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.navbar {
  @include container-padding;
}

.ctm-container {
    @include container-padding;
    h3 {
      color: black
    }
}

@include mobile {
  /deep/ .navbar-brand {
      margin-right: 0;
  }
/*   /deep/ .navbar-nav{
    box-shadow: none !important;
    background-color: transparent !important;
    display: flex;
  } */
  .navbar {
    padding: 1rem 2rem;
    
    .btn-layout{
     font-size: .875rem !important;
     font-weight: initial;
     padding: .7rem 2.2rem;
     background-color: $blue;
    }
  }

  /deep/ .nav.item button {
    color: $white !important;
  }
}

/deep/ .nav-item {
  margin-right: 0rem;
  @include mobile {
    padding: 0rem;
  }
}

/* .navbar {
  @include mobile {
    padding: 1rem;
  }
} */

/deep/.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
/deep/.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.add-to-home-screen {
		position: fixed;
		bottom: 2rem;
		left: 2rem;
		@include media(mobile, tablets) {
			left: 1rem;
		}
		z-index: 4;
		font-weight: bold;
		text-transform: uppercase;
	}

</style>


// WEBPACK FOOTER //
// src/components/layouts/PublicMenuLayout.vue